import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5591cac7")

_pushScopeId("data-v-5591cac7")
const _hoisted_1 = { class: "main" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "content-bg" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "content-bgcolor" }, null, -1)
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_the_header = _resolveComponent("the-header")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_the_header),
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
})